// Alpha and space 
export const NAME_REGEX = /^[a-zA-Z\s]+$/;

export const MOBILE_REGEX = /^[6789]\d{9}$/;

// STD regex check for start with 0 and length 

export const EMAIL_REGEX = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;


// [@INFO]Inorder to restrict fields, maxLength works for 'text',
// digit strict digit regex can be changed to string where digits allowed

// Be aware, that \W leaves the underscore. A short equivalent for [^a-zA-Z0-9] would be [\W_]

// text.replace(/[\W_]+/g," ");
// \W is the negation of shorthand \w for [A-Za-z0-9_] word characters (including the underscore)




// WEBPACK FOOTER //
// ./src/utilities/validationRules.js